export default __webpack_public_path__ + "static/media/no-teams-found.89582846.svg";